export default {
  name: 'checkbox',
  type: 'action',
  isRequired: true,
  essential: false
}
